import { useLocation, useNavigate } from "react-router-dom";
import "../../css/Footer/Footer.css";
import { useContext } from "react";
import { AuthContext } from "../SessionChecker/SessionChecker";
function Footer({ theme }) {
  const location = useLocation();
  const navigate = useNavigate();

  const { sessionStatus, currentUserUsername } = useContext(AuthContext); 
  return (
    <div className={`footerDiv ${theme}`}>
      <button
        className={`footerButton ${theme} ${location.pathname === "/" || location.pathname.startsWith("/token") ? "active" : ""}`}
        onClick={() => navigate("/")}
      >
        <img src="/icons/home.png" className={`icon ${theme}`}></img>
      </button>

      <button
        className={`footerButton ${theme} ${location.pathname.startsWith("/search") && "active"}`}
        onClick={() => navigate("/search")}
      >
        <img src="/icons/search.png" className={`icon ${theme}`}></img>
      </button>

      <button
        className={`footerButton ${theme} ${location.pathname.startsWith("/add_product") && "active"}`}
        onClick={() => navigate("/add_product")}
      >
        <img src="/icons/add.png" className={`icon ${theme}`}></img>
      </button>

      <button
        className={`footerButton ${theme} ${location.pathname === "/notifs" && "active"}`}
        onClick={() => navigate("/notifs")}
      >
        <img src="/icons/notifs.png" className={`icon ${theme}`}></img>
      </button>

      {/* <button
        className={`footerButton ${theme} ${location.pathname === "/settings" && "active"}`}
        onClick={() => navigate("/settings")}
      >
        <img src="/icons/settings.png" className={`icon ${theme}`}></img>
      </button> */}

      <button
        className={`footerButton ${theme} ${(location.pathname === "/" + currentUserUsername || location.pathname === "/languages" || location.pathname === "/sessions" || location.pathname == "/edit_profile" || location.pathname == "/authentication" || location.pathname == "/interal_accounting" || location.pathname == "/licenses" || location.pathname == "/history") && "active"}`}
        onClick={() => navigate(`/${currentUserUsername}`)}
      >
        <img src="/icons/profile.png" className={`icon ${theme}`}></img>
      </button>
    </div>
  );
}

export default Footer;
